// extracted by mini-css-extract-plugin
module.exports = {"formItem":"ReportPosAllTrx_formItem__3hg-J"};